import types from "rdx/modules/bypassPaywall/types";
import createAction from "rdx/utils/createAction";

export default {
  updateBypassPaywall: (payload) => createAction(types.UPDATE_BYPASS_PAYWALL, payload),
  resetBypassPaywall: (payload) => createAction(types.RESET_BYPASS_PAYWALL, payload),
};
